import React, { memo } from 'react';
import styled from 'styled-components';
import { FaExchangeAlt } from 'react-icons/fa';

import { BuscaNcm } from '~/components/BuscaNcm';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { useAlteracaoNcmLote } from '../../hooks/useAlteracaoNcmLote';

const TransferirNcmComponent: React.FC = () => {
  const { formNcmLote, onTransfer, loading } = useAlteracaoNcmLote();

  const {
    control,
    formState: { errors },
  } = formNcmLote;

  const isBusy = loading.table || loading.submit;
  const hasNcmError = Boolean(errors?.cod_ncm);

  return (
    <Container>
      <FieldGroup>
        <Label>Novo NCM:</Label>

        <InputWrapper>
          <BuscaNcm
            label=""
            placeholder="Selecione o NCM"
            control={control}
            isUpdate={false}
            init
            invalid={hasNcmError}
            isDisabled={isBusy}
            name="cod_ncm"
          />
        </InputWrapper>
      </FieldGroup>

      <Actions>
        <CustomButtonNovo
          onClick={async () => {
            await onTransfer();
          }}
          disabled={loading.submit || loading.table}
          showLoading={loading.submit}
          showLoadingIcon={loading.submit}
          label="Transferir"
          icon={FaExchangeAlt}
          iconSize={20}
        />
      </Actions>
    </Container>
  );
};

TransferirNcmComponent.displayName = 'TransferirNcm';

export const TransferirNcm = memo(TransferirNcmComponent);

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 20px;
`;

const FieldGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

const Label = styled.span`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

const InputWrapper = styled.div`
  flex: 1;
  margin-bottom: 26px;
  min-width: min(30rem, 100%);
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;
